module.exports = __webpack_public_path__ + "static/media/right-arrows-couple.416dfd28.svg";